// banner
(() => {
  const cookieBanner = document.getElementById('cookie-consent');
  const cookieButton = document.getElementById('cookie-consent-button');

  function hideCookieBanner() {
    if (!cookieBanner) return;
    cookieBanner.setAttribute('inert', '');
  }

  function hasSessionItem() {
    return sessionStorage.getItem('cookieAccepted') === 'true';
  }

  function setSessionItem() {
    sessionStorage.setItem('cookieAccepted', 'true');
    hideCookieBanner();
  }

  if (cookieButton) {
    cookieButton.addEventListener('click', setSessionItem);
  }

  if (hasSessionItem()) {
    hideCookieBanner();
  }
})();